<template>
    <div
        style="max-height: 300px"
        class="overflow-y-auto overflow-x-hidden">
        <p>
            {{ data }}
        </p>
    </div>
</template>
<script lang="ts" setup>
const store = $store()
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const data: any = ref([])

onBeforeMount(() => {
  try {
    const nodeConnection = params?.value?.data.nodeConnection
    const nodeTypeName = nodeConnection?.nodeType?.name || ''
    const locationName = nodeConnection?.location?.locationName || ''

    data.value = `${nodeTypeName} - ${locationName}`
  } catch (e) {
    data.value = []
  }
})
</script>
